import { combineReducers } from 'redux';
import { alarmDataReducer } from './alarm-data-reducer';
import { bedDetailsReducer } from "./bed-details-reducer";
import { configReducer } from './config-reducer';
import { deviceVitalDataReducer } from './device-vital-data-reducer';
import { notificationDataReducer } from './notification-data-reducer';
import { patientDataReducer } from './patient-data-reducer';
import { wardDetailsReducer } from './ward-details-reducer';
import { hospitalDataReducer } from './hospital-data-reducer';
import storage from 'redux-persist/lib/storage';
import { Types } from '../actions/actionTypes';
import { userDataReducer } from './user-data-reducer';

const appReducer = combineReducers({

    bedDetailsReducer: bedDetailsReducer,
    wardDetailsReducer: wardDetailsReducer,
    configReducer: configReducer,
    patientDataReducer: patientDataReducer,
    deviceVitalDataReducer: deviceVitalDataReducer,
    alarmDataReducer: alarmDataReducer,
    notificationDataReducer: notificationDataReducer,
    hospitalDataReducer: hospitalDataReducer,
    userDataReducer: userDataReducer,
});

export const rootReducer = (state, action) => {

    if (action.type === Types.CLEAR_STORE) {
        // for all keys defined in your persistConfig(s)
        storage.removeItem('persist:charting-root')
        return appReducer(undefined, action);

    }

    return appReducer(state, action);

};